import type { PackageSelectionPayment } from './packageSelectionBurnQuote'
import PackageSelectionQuantityPrice from './PackageSelectionQuantityPrice'
import PackageSelectionBurnPrice from './PackageSelectionBurnPrice'

interface Props {
  price: number
  memberPrice: number
  payment?: { regular: PackageSelectionPayment, member: PackageSelectionPayment }
  fetching?: boolean
}

function PackageSelectionQuantityBurnPrice({ price, memberPrice, payment, fetching }: Props) {
  return <span aria-busy={fetching}>
    {!!payment && <PackageSelectionBurnPrice price={price} memberPrice={memberPrice} payment={payment} size="S" />}
    {!payment && <PackageSelectionQuantityPrice price={price} memberPrice={memberPrice} />}
  </span>
}

export default PackageSelectionQuantityBurnPrice
